const constRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => import("@/views/login/login"),
    meta: { title: '登录' }
  },
  {
    path: '/:pathMatch(.*)',
    component: () => import('@/views/404')
  }
];
export default constRoutes;